/**
 * Accessible tabs
 * (https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-1/tabs.html)
 *
 */
 var component_accessible_tabs = function(args) {

  var tablist = args.tablist; // elements with [role="tablist"]
  var tabs = args.tabs; // elements with [role="tab"]
  var panels = args.panels; // elements with [role="tabpanel"]
  var url = location.href.replace(/\/$/, '');

  // validate
  if (!tablist || !tabs.item(0) || !panels.item(0)) {
    console.log(
      'Missing arguments for accessible tabs component',
      '\n' , 'tablist: ', tablist,
      '\n' , 'tabs: ', tabs,
      '\n' , 'panels: ', panels
    );
    return;
  }

  // Determine whether there should be a delay
  // when user navigates with the arrow keys
  function determineDelay () {
    var hasDelay = tablist.hasAttribute('data-delay');
    var delay = 0;

    if (hasDelay) {
      var delayValue = tablist.getAttribute('data-delay');
      if (delayValue) {
        delay = delayValue;
      }
      else {
        // If no value is specified, default to 300ms
        delay = 300;
      }
    }

    return delay;
  }

  var delay = determineDelay();

  // Forward declaration (defined below, referenced in deactivateTabs)
  var focusEventHandler;


  // Add or substract depending on key pressed
  var direction = {
    ArrowLeft: -1,
    ArrowUp: -1,
    ArrowRight: 1,
    ArrowDown: 1
  };

  // For easy reference
  var keys = {
    end: 'End',
    home: 'Home',
    left: 'ArrowLeft',
    up: 'ArrowUp',
    right: 'ArrowRight',
    down: 'ArrowDown',
    delete: 'Delete'
  };

  // Deactivate all tabs and tab panels
  function deactivateTabs () {
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
      tabs[t].removeEventListener('focus', focusEventHandler);
    }

    for (var p = 0; p < panels.length; p++) {
      panels[p].setAttribute('hidden', '');
    }
  }

  // Activates any given tab panel
  function activateTab (tab, setFocus) {
    // Deactivate all other tabs
    deactivateTabs();

    // Remove tabindex attribute
    tab.removeAttribute('tabindex');

    // Set the tab as selected
    tab.setAttribute('aria-selected', 'true');

    // Get the value of aria-controls (which is an ID)
    var controls = tab.getAttribute('aria-controls');

    // Remove hidden attribute from tab panel to make it visible
    document.getElementById(controls).removeAttribute('hidden');

    // Set focus when required
    if (setFocus) {
      tab.focus();
    }
  }

  // Only activate tab on focus if it still has focus after the delay
  focusEventHandler = function (event) {
    var target = event.target;

    setTimeout(() => {
      let focused = document.activeElement;

      if (target === focused) {
        activateTab(target, false);
      }
    }, delay, target);
  };

  // When a tab is clicked, activateTab is fired to activate it
  function clickEventListener (event) {
    var tab = event.target;
    activateTab(tab, false);

    // set url of the tab
    var newUrl;
    var hash = tab.getAttribute('aria-controls');
    newUrl = url.split('#')[0] + '#' + hash;
    history.replaceState(null, null, newUrl);
  }

  // Make a guess
  function focusFirstTab () {
    tabs[0].focus();
  }

  // Make a guess
  function focusLastTab () {
    tabs[tabs.length - 1].focus();
  }

  // Either focus the next, previous, first, or last tab
  // depening on key pressed
  function switchTabOnArrowPress (event) {
    var pressed = event.key;

    for (var x = 0; x < tabs.length; x++) {
      tabs[x].addEventListener('focus', focusEventHandler);
    }

    if (direction[pressed]) {
      var target = event.target;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        }
        else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        }
        else if (pressed === keys.right || pressed === keys.down) {
          focusFirstTab();
        }
      }
    }
  }

  // When a tablistâ€™s aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  function determineOrientation (event) {
    var key = event.key;
    var vertical = tablist.getAttribute('aria-orientation') === 'vertical';
    var proceed = false;

    if (vertical) {
      if (key === keys.up || key === keys.down) {
        event.preventDefault();
        proceed = true;
      }
    }
    else {
      if (key === keys.left || key === keys.right) {
        proceed = true;
      }
    }

    if (proceed) {
      switchTabOnArrowPress(event);
    }
  }

  // Handle keydown on tabs
  function keydownEventListener (event) {
    var key = event.key;

    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        activateTab(tabs[tabs.length - 1]);
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        activateTab(tabs[0]);
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
    }
  }

  // Deletes a tab and its panel
  function deleteTab (event) {
    var target = event.target;
    var panel = document.getElementById(target.getAttribute('aria-controls'));

    target.parentElement.removeChild(target);
    panel.parentElement.removeChild(panel);
  }

  // Detect if a tab is deletable
  function determineDeletable (event) {
    var target = event.target;

    if (target.getAttribute('data-deletable') !== null) {
      // Delete target tab
      deleteTab(event, target);

      // Update arrays related to tabs widget
      generateArrays();

      // Activate the closest tab to the one that was just deleted
      if (target.index - 1 < 0) {
        activateTab(tabs[0]);
      }
      else {
        activateTab(tabs[target.index - 1]);
      }
    }
  }

  // Handle keyup on tabs
  function keyupEventListener (event) {
    var key = event.key;

    switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.delete:
        determineDeletable(event);
        break;
    }
  }

  function addListeners (index) {
    tabs[index].addEventListener('click', clickEventListener);
    tabs[index].addEventListener('keydown', keydownEventListener);
    tabs[index].addEventListener('keyup', keyupEventListener);

    // Build an array with all tabs (<button>s) in it
    tabs[index].index = index;
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (tablist) {
      var currentTab = false;

      // deep linking
      if (location.hash) {
        var hash = url.split('#');
        currentTab = document.querySelector('button[aria-controls="' + hash[1] + '"]');
      }

      if (currentTab) {
        activateTab(currentTab, false);
      } else {
        // Activate first tab on page load
        activateTab(tabs[0], false);
      }

      // Bind listeners
      for (var i = 0; i < tabs.length; ++i) {
        addListeners(i);
      }
    }
  });

  // make the call chainable
  return this;
};
